import React, { forwardRef, useMemo } from 'react';

import styled from 'styled-components';

import { InputWrapper } from 'components/uikit/Form/TextInput/TextInput.styles';

const NormalizedTextInputContainer = styled.div`
  --default-normalized-border-radius: ${({ size }) => {
    switch (size) {
      case 's':
        return '8px';

      case 'm':
        return '12px';

      default:
        return '16px';
    }
  }};
  --normalized-border-radius: var(--default-normalized-border-radius);

  ${InputWrapper} {
    border-radius: var(--normalized-border-radius);
  }
`;

export const withNormalizedTextInputStyles = (Component, defaultProps = {}) => {
  const { displayName: displayNameComponent, name: nameComponent } = Component;

  const NormalizedTextInputStyle = forwardRef((props, ref) => {
    const { className, size, ...rest } = useMemo(() => {
      const result = { ...props };

      Object.entries(defaultProps).forEach(([key, value]) => {
        if (typeof value === 'function') {
          result[key] = value(props);

          return;
        }

        result[key] = value;
      });

      return result;
    }, [props]);

    // eslint-disable-next-line react/react-in-jsx-scope
    return (
      <NormalizedTextInputContainer className={className} size={size}>
        <Component {...rest} ref={ref} size={size} />
      </NormalizedTextInputContainer>
    );
  });

  NormalizedTextInputStyle.displayName = `withNormalizedTextInputStyles(${
    displayNameComponent || nameComponent
  })`;

  return NormalizedTextInputStyle;
};
